import React from "react";
import { FiGithub, FiLinkedin, FiMail } from "react-icons/fi";
import { SiKofi } from "react-icons/si";
import { useLanguage } from "../../i18n/LanguageContext";
import { profile } from "../../data/profile";
import { Icon } from "../common/Icon";
import { smoothScrollToTop } from "../../utils/smoothScroll";
import "./Footer.css";

export function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const scrollTop = (e: React.MouseEvent) => {
    e.preventDefault();
    smoothScrollToTop();
  };

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__brand">
          <span className="footer__name">{profile.name}</span>
          <span className="footer__role mono">{t.footer.role}</span>
        </div>

        <div className="footer__social">
          <a href={profile.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub" data-cursor="hover">
            <Icon icon={FiGithub} />
          </a>
          <a
            href={profile.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            data-cursor="hover"
          >
            <Icon icon={FiLinkedin} />
          </a>
          <a href={profile.kofi} target="_blank" rel="noopener noreferrer" aria-label="Ko-fi" data-cursor="hover">
            <Icon icon={SiKofi} />
          </a>
          <a href={`mailto:${profile.email}`} aria-label="Email" data-cursor="hover">
            <Icon icon={FiMail} />
          </a>
        </div>

        <div className="footer__meta">
          <a href="#about" onClick={scrollTop} className="footer__top mono" data-cursor="hover">
            {t.footer.backToTop}
          </a>
          <span className="footer__copyright mono">
            © {year} {profile.name}. {t.footer.rights}
          </span>
        </div>
      </div>
    </footer>
  );
}
